import type { FaireProductEntity } from "../../entity_types/product";

export const p_6smav2sxfz: FaireProductEntity = {
  token: "p_6smav2sxfz",
  type: "product",
  name: "camping watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/ae41974ded0371db94e82ea345a8a2d7056997beeb417715d0e8fac650ce1641.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6755338a455133504cbd735f148d368c87ce8e17e13dae68dbb5340625e2bac9.jpeg",
    "https://cdn.faire.com/fastly/ed8a8765a42d37f463ad9a70183162729f9c852bcb856b43a5418636320fa9f5.jpeg",
    "https://cdn.faire.com/fastly/9e379568da0a43cbe45ecfd70cbad4000f3bf6f795fa4f1c4ea3777262390e4b.jpeg",
    "https://cdn.faire.com/fastly/a0e0ca1ed19a4726188afab24e296523c7feba1952a8cd9234d96b8cc47380fc.jpeg",
    "https://cdn.faire.com/fastly/abb20fc614f60aef15662ce43d19d61cc1270e9f162d96d42f63625102705674.jpeg",
    "https://cdn.faire.com/fastly/bcd297a34612e0c05bf8f0ce69d6191750d2635542e2686bc7589ecc9f2487c1.jpeg",
    "https://cdn.faire.com/fastly/696c4b64bcfde43657ae83b2279fd119ba0f75b0dfd41c2756eb8b87a8ca6f5a.jpeg",
    "https://cdn.faire.com/fastly/ab1edfba8904a848cf9ba16d49fb460430e12c1b04e1a1e396366d0bf649e6cb.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve camping illustrations — a vintage camper, lantern, campfire, tent, canoe, s'mores, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA favorite in mountain-town and outdoor-focused boutiques. Strong summer and back-to-school seller.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:06.063Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
